import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { translate } from 'react-translate';
import { Button, Dropdown, Form, Header, Icon, Label, Modal, Table } from 'semantic-ui-react';
import envList from '../../../constants/envList';
import API from '../../../services/Api';
import StandardService from '../../../services/StandardService';
import { TechnicalInfoIcon } from '../../shared/TechnicalInfoIcon';
import ProductType from '../../../constants/ProductType';
import UserService from '../../../services/userService';

// const suspentesTrad = 15;
const kitFit032 = 'https://www.knaufinsulation.fr/produits/ki-fit-032';
const kitFit035 = 'https://www.knaufinsulation.fr/produits/ki-fit-035';
const suspentesUrl = 'https://www.knaufinsulation.fr/produits/suspentes-rt-max';
const adhesifRtmaxPdf = 'https://fr.knaufinsulation.accounts.intracto.com/produits/adhesif-rt-max';
const masticRtPdf = 'https://fr.knaufinsulation.accounts.intracto.com/produits/mastic-rt';
const solidoublePdf = 'https://www.knaufinsulation.fr/produits/adhesif-solidouble';


class ComponentTable extends Component {
  static propTypes = {
    location: PropTypes.any,
    epaisseurChevron: PropTypes.number,
    isoValue: PropTypes.number,
    onConformitychange: PropTypes.func,
    onIsEnoughChange: PropTypes.func,
    onStandardTotalChange: PropTypes.func,
    onThermalChange: PropTypes.func,
    productOptions: PropTypes.object,
    resValue: PropTypes.number,
    showMonocouche: PropTypes.bool,
    suspentesTrad: PropTypes.object,
    t: PropTypes.func,
  };

  constructor(props) {
    super(props);
    this.state = {
      isoValue: props.isoValue,
      suspentes: props.isoValue * 2.5,
      suspentesQuantity: (props.isoValue * 2.5) / 50,
      suspentesPrice: props.suspentesTrad,
      membraneRouleaux: Math.ceil((props.isoValue * 1.3) / 75),
      adhesifRTMax: props.isoValue * 2.0,
      adhesifRTMaxQuantity: (props.isoValue * 2.0) / 40,
      solidouble: props.isoValue * 2.35,
      solidoubleQuantity: Math.ceil((props.isoValue * 2.35) / 40),
      masticRT: props.isoValue * 0.5,
      masticrtQuantity: Math.ceil((props.isoValue * 0.5) / 12),
      state: window.innerWidth,
    };
  }

  componentDidMount() {
    const {
      showMonocouche,
      resValue,
      epaisseurChevron,
      isoValue,
    } = this.props;

    if (
      (epaisseurChevron === 60
        && resValue === 10
        && showMonocouche === false)
      || (resValue === 10 && showMonocouche === true)
    ) {
      this.setState({ modalOpen: true });
    } else if (
      resValue >= 8.5
      && showMonocouche === true
    ) {
      this.setState({ modalStandardMonocoucheOpen: true });
    } else {
      Promise.all([
        API.getPreselect(resValue, showMonocouche, epaisseurChevron),
        API.getProducts(),
      ]).then(([{ data: { preselect } }, res]) => {
        const {
          membrane,
          productOptions,
          adhesifStandardPrice,
          solidoubleStandardPrice,
          masticStandardPrice,
          suspentes,
          suspentesStandardPrice,
          membraneItem,
          suspentesItem,
          entreChevronsItem,
          sousChevronsItem,
          selectedAdhesif,
        } = StandardService.getProducts(envList.CA.path, preselect, res, isoValue);

        const costs = StandardService.calculateCost([
          {
            type: ProductType.BETWEEN_CHEVRON,
            productData: entreChevronsItem,
          },
          {
            type: ProductType.UNDER_CHEVRON,
            productData: sousChevronsItem,
          },
          {
            type: ProductType.MEMBRANE,
            productData: membraneItem,
          },
          {
            type: ProductType.SHROUD,
            productData: suspentesItem,
          },
          {
            type: ProductType.ADHESIVE,
            productData: selectedAdhesif,
          },
          {
            type: ProductType.SOLIDOUBLE,
            productData: {
              quantity: Math.ceil((isoValue * 2.35) / 40),
              price: solidoubleStandardPrice,
            },
          },
          {
            type: ProductType.MASTIC,
            productData: {
              quantity: Math.ceil((isoValue * 0.5) / 12),
              price: masticStandardPrice,
            },
          },
        ], isoValue);

        const {
          betweenChevron,
          underChevron,
          membrane: membraneCost,
          shroud,
          adhesive,
          solidouble,
          mastic: masticCost,
        } = costs;

        this.setState(
          {
            ...adhesive,
            ...betweenChevron,
            ...masticCost,
            ...membraneCost,
            ...shroud,
            ...solidouble,
            ...underChevron,
            adhesifPrice: adhesifStandardPrice,
            entreChevronsItem,
            entreChevronsOptions: productOptions,
            masticrtPrice: masticStandardPrice,
            membraneItem,
            membraneItemPriceBrut: membraneItem.price,
            membraneOptions: membrane,
            membranePareVapeur: isoValue * membraneItem.m2perpiece,
            selectedAdhesif,
            solidoublePrice: solidoubleStandardPrice,
            sousChevronsItem,
            sousChevronsOptions: productOptions,
            suspentesItem,
            suspentesOptions: suspentes,
            suspentesPrice: suspentesStandardPrice,
          }, () => {
            this.calculateStandardTotal();
            this.calculateResValue();
          }
        );

        this.setState({ modalStandardMonocoucheOpen: false });
      });
    }
    window.addEventListener('resize', this.resize.bind(this));
  }

  resize = () => {
    this.setState({ size: window.innerWidth });
  }

  handleOpen = () => this.setState({ modalStandardMonocoucheOpen: true });

  handleClose = () => this.setState({ modalStandardMonocoucheOpen: false });

  handleOpenConfig = () => this.setState({ modalOpen: true });

  handleCloseConfig = () => this.setState({ modalOpen: false });

  checkConformity = () => {
    const { entreChevronsItem, sousChevronsItem, thermalValue } = this.state;
    const { showMonocouche } = this.props;
    const { resValue } = this.props;
    const { onConformitychange, onIsEnoughChange } = this.props;

    const conformity = (
      showMonocouche
      || (
        entreChevronsItem
        && (entreChevronsItem.cpt === 'OUI' || entreChevronsItem.cpt === '1')
      )
    )
    && sousChevronsItem
    && (sousChevronsItem.cpt === 'OUI' || sousChevronsItem.cpt === '1');

    const isEnough = resValue <= thermalValue;
    onConformitychange(conformity);
    onIsEnoughChange(isEnough);
  }

  calculateEntreChevrons = () => {
    const { entreChevronsItem } = this.state;
    const { isoValue } = this.props;

    const costs = StandardService.calculateCost([
      {
        type: ProductType.BETWEEN_CHEVRON,
        productData: entreChevronsItem,
      },
    ], isoValue, envList.CA.path);

    this.setState({
      tarifPerSurface: costs.betweenChevron.tarifPerSurface,
    }, () => {
      this.checkConformity();
      this.calculateStandardTotal();
    });
  }


  calculateSousChevrons = () => {
    const { sousChevronsItem } = this.state;
    const { isoValue } = this.props;

    const costs = StandardService.calculateCost([
      {
        type: ProductType.UNDER_CHEVRON,
        productData: sousChevronsItem,
      },
    ], isoValue, envList.CA.path);

    this.setState({
      tarifOnSurface: costs.underChevron.tarifOnSurface,
    }, () => {
      this.checkConformity();
      this.calculateStandardTotal();
    });
  }

  calculateSuspentes = () => {
    const { suspentesItem } = this.state;
    const { isoValue } = this.props;

    const costs = StandardService.calculateCost([
      {
        type: ProductType.SHROUD,
        productData: suspentesItem,
      },
    ], isoValue, envList.CA.path);

    this.setState({
      tarifDeSurface: costs.shroud.tarifDeSurface,
    }, () => {
      this.checkConformity();
      this.calculateStandardTotal();
    });
  }

  calculateStandardTotal = () => {
    const { showMonocouche, onStandardTotalChange } = this.props;
    const {
      tarifPerSurface,
      tarifOnSurface,
      tarifDeSurface,
      tarifMembrane,
      adhesifCost,
      tarifSolidouble,
      tarifMasticRt,
    } = this.state;

    const totalEntreChevrons = showMonocouche ? 0 : Number(tarifPerSurface || 0);
    const totalSousChevrons = Number(tarifOnSurface || 0);
    const totalSuspentes = Number(tarifDeSurface || 0);
    const totalMembrane = Number(tarifMembrane || 0);
    const totalAdhesif = Number(adhesifCost || 0);
    const totalSolidouble = Number(tarifSolidouble || 0);
    const totalMasticRT = Number(tarifMasticRt || 0);
    const standardTotal = (
      totalEntreChevrons
      + totalSousChevrons
      + totalSuspentes
      + totalMembrane
      + totalAdhesif
      + totalSolidouble
      + totalMasticRT
    ).toFixed(1);
    onStandardTotalChange(standardTotal);
  }

  calculateMembrane = () => {
    const { membraneItem, isoValue } = this.state;

    const costs = StandardService.calculateCost([
      {
        type: ProductType.MEMBRANE,
        productData: membraneItem,
      },
    ], isoValue, envList.CA.path);

    this.setState(
      {
        tarifMembrane: costs.membrane.tarifMembrane,
      },
      () => this.calculateStandardTotal()
    );
  }

  calculateResValue = () => {
    const { entreChevronsItem, sousChevronsItem } = this.state;
    const { onThermalChange, showMonocouche } = this.props;
    const entreChevronsRes = (entreChevronsItem || { resistance: 0 })
      .resistance;
    const sousChevronsRes = (sousChevronsItem || { resistance: 0 })
      .resistance;

    const thermalValue = (
      ((!showMonocouche && Number(entreChevronsRes)) || 0) + Number(sousChevronsRes)
    ).toFixed(1);

    this.setState({
      thermalValue,
    }, () => {
      onThermalChange(thermalValue);
      this.checkConformity();
    });
  }

  calculateAdhesif = () => {
    const { selectedAdhesif, isoValue } = this.state;

    const costs = StandardService.calculateCost([
      {
        type: ProductType.ADHESIVE,
        productData: selectedAdhesif,
      },
    ], isoValue, envList.CA.path);

    this.setState(
      {
        adhesifCost: costs.adhesive.adhesifCost,
      },
      () => this.calculateStandardTotal()
    );
  }

  calculateSolidouble = () => {
    const { solidoublePrice, isoValue } = this.state;

    const {
      solidouble: {
        tarifSolidouble,
      },
    } = StandardService.calculateCost([
      {
        type: ProductType.SOLIDOUBLE,
        productData: {
          quantity: Math.ceil((isoValue * 2.35) / 40),
          price: solidoublePrice,
        },
      },
    ], isoValue, envList.CA.path);

    this.setState(
      {
        tarifSolidouble,
      },
      () => this.calculateStandardTotal()
    );
  }

  changeSolidoublePrice = (_, val, noFormat) => {
    this.setState(
      {
        solidoublePrice: val.value,
        solidoubleNoFormat: noFormat,
      }, () => {
        this.calculateSolidouble();
      });
  }

  calculateMasticrt = () => {
    const { masticrtQuantity, masticrtPrice } = this.state;
    const tarifMasticRt = masticrtQuantity * masticrtPrice;
    this.setState(
      {
        tarifMasticRt,
      },
      () => this.calculateStandardTotal()
    );
  }

  changeEntreChevronsPrice = (_, val, noFormat) => {
    const { entreChevronsOptions, entreChevronsItem } = this.state;

    entreChevronsItem.price = val.value;
    entreChevronsItem.noFormat = noFormat;

    for (let i = 0; i < entreChevronsOptions.length; i++) {
      if (entreChevronsOptions[i].text === entreChevronsItem.name) {
        entreChevronsOptions[i].price = val.value;
        entreChevronsOptions[i].noFormat = noFormat;
      }
    }

    this.setState({ entreChevronsOptions, entreChevronsItem }, () => {
      this.calculateEntreChevrons();
    });
  }

  changeSuspentesPrice = (_, val, noFormat) => {
    const { suspentesOptions, suspentesPrice, suspentesItem } = this.state;

    for (let i = 0; i < suspentesOptions.length; i++) {
      if (suspentesOptions[i].text === suspentesItem.name) {
        suspentesOptions[i].value.price = val.value;
        suspentesOptions[i].value.noFormat = noFormat;
      }
    }

    this.setState({
      suspentesOptions,
      suspentesPrice: val.value,
      suspentesItem: {
        ...suspentesItem,
        price: val.value,
        noFormat,
      },
    }, () => {
      this.calculateSuspentes();
    });
  }

  changeMembranePrice = (_, val, noFormat) => {
    const { membraneOptions, membraneItem } = this.state;

    for (let i = 0; i < membraneOptions.length; i++) {
      if (membraneOptions[i].text === membraneItem.name) {
        membraneOptions[i].value.price = val.value;
        membraneOptions[i].value.noFormat = noFormat;
      }
    }
    this.setState({
      membraneOptions,
      membraneItemPriceBrut: val.value,
      membranePrice: {
        ...this.state.membraneItem,
        price: val.value,
        noFormat,
      },
    }, () => {
      this.calculateMembrane();
    });
  }

  changeMasticrtPrice = (e, val, noFormat) => {
    this.setState({ masticrtPrice: val.value, masticNoFormat: noFormat }, () => {
      this.calculateMasticrt();
    });
  }

  changeSousChevronsPrice = (_, val, noFormat) => {
    const { sousChevronsOptions, sousChevronsItem } = this.state;

    sousChevronsItem.price = val.value;
    sousChevronsItem.noFormat = noFormat;

    for (let i = 0; i < sousChevronsOptions.length; i++) {
      if (sousChevronsOptions[i].text === sousChevronsItem.name) {
        sousChevronsOptions[i].value.price = val.value;
        sousChevronsOptions[i].value.noFormat = noFormat;
      }
    }

    this.setState({ sousChevronsOptions, sousChevronsItem }, () => {
      this.calculateSousChevrons();
    });
  }

  changeEntreChevrons = (_, val) => {
    const { entreChevronsItem } = this.state;
    entreChevronsItem.price = val.value;
    const entreChevronsPriceBrut = entreChevronsItem.price;

    this.setState(
      {
        entreChevronsItem,
        entreChevronsPriceBrut,
      },
      () => {
        this.calculateEntreChevrons();
        this.calculateResValue();
      }
    );
  }

  changeAdhesifPrice = (_, val, noFormat) => {
    const { selectedAdhesif } = this.state;
    const adhesifPrice = val.value;

    selectedAdhesif.price = adhesifPrice;
    selectedAdhesif.noFormat = noFormat;

    this.setState(
      {
        selectedAdhesif,
        adhesifPrice,
      },
      () => { this.calculateAdhesif(); },
    );
  }

  changeSousChevrons = (_, val) => {
    if (val == null) return;

    const sousChevronsItem = val.value;
    const sousChevronsPriceBrut = sousChevronsItem.price;
    this.setState(
      {
        sousChevronsItem,
        sousChevronsPriceBrut,
      },
      () => {
        this.calculateSousChevrons();
        this.calculateResValue();
      }
    );
  }

  changeMembrane = (_, val) => {
    const membraneItem = val.value;
    const membraneItemPriceBrut = membraneItem.price;
    this.setState(
      {
        membraneItem,
        membraneItemPriceBrut,
      },
      () => { this.calculateMembrane(); }
    );
  }

  clickDownloadPdf = (urlToOpen) => {
    const windowRef = window.open(urlToOpen, '_blank');
    windowRef.focus();
  }

  render = () => {
    const {
      showMonocouche,
      t,
      location: { state },
    } = this.props;
    const {
      adhesifBox,
      adhesifCost,
      adhesifNoFormat,
      adhesifPrice,
      entreChevronsItem,
      entreChevronsOptions,
      masticNoFormat,
      masticRT,
      masticrtPrice,
      masticrtQuantity,
      membraneItem,
      membraneItemPriceBrut,
      membraneOptions,
      membranePareVapeur,
      membraneRouleaux,
      modalOpen,
      modalStandardMonocoucheOpen,
      nbreRouleau,
      nbRouleau,
      pareVapeur,
      size,
      solidouble,
      solidoubleNoFormat,
      solidoublePrice,
      solidoubleQuantity,
      sousChevronsItem,
      sousChevronsOptions,
      surface,
      surfaceSousChevrons,
      suspentes,
      suspentesItem,
      suspentesOptions,
      suspentesPrice,
      suspentesQuantity,
      tarifDeSurface,
      tarifMasticRt,
      tarifMembrane,
      tarifOnSurface,
      tarifPerSurface,
      tarifSolidouble,
      usedAdhesif,
    } = this.state;

    const token = sessionStorage.getItem('USER_TOKEN');

    return (
      <div>
        <Table basic="very" className="tableStandard">
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell />
              <Table.HeaderCell>
                {t('standard_table_title')}
              </Table.HeaderCell>
              <Table.HeaderCell />
              <Table.HeaderCell>
                {t('standard_table_title_quantity')}
              </Table.HeaderCell>
              <Table.HeaderCell>
                {t('standard_table_title_unité')}
              </Table.HeaderCell>
              <Table.HeaderCell>
                {t('standard_table_title_surface')}
              </Table.HeaderCell>
            </Table.Row>
          </Table.Header>

          <Table.Body>
            { !showMonocouche && (
            <Table.Row>
              <Table.Cell>1. </Table.Cell>
              <Table.Cell className="cellTableStandard">
                {t('standard_table_iso_entre_chevrons')}
                <TechnicalInfoIcon
                  t={t}
                  onClick={() => this.clickDownloadPdf(
                    entreChevronsItem && entreChevronsItem.link.length > 0
                      ? entreChevronsItem.link
                      : kitFit032
                  )}
                />
                <br />
                <Dropdown
                  search
                  selection
                  disabled
                  options={entreChevronsOptions}
                  value={entreChevronsItem}
                  onChange={(e, val) => this.changeEntreChevrons(e, val)}
                />
              </Table.Cell>
              <Table.Cell className="cellTable">
                {(surface || 0).toFixed(2)}
                {' '}
                {t('standard_table_iso_entre_chevrons_surface')}
              </Table.Cell>
              <Table.Cell className="cellTableQuantity">
                {(nbRouleau || 0).toFixed(2)}
                {t('standard_table_iso_entre_chevrons_rouleau')}
              </Table.Cell>
              <Table.Cell className="cellTableStandard">
                <Form className="inputInTable">
                  <Form.Input
                    disabled={token === null || UserService.isUser()}
                    max={100}
                    onClick={e => e.target.select()}
                    placeholder=""
                    precision={2}
                    step={0.10}
                    type="number"
                    width={8}
                    value={
                      entreChevronsItem && entreChevronsItem.noFormat
                        ? entreChevronsItem && entreChevronsItem.price
                        : Number((entreChevronsItem && entreChevronsItem.price) || 0).toFixed(2)
                    }
                    onChange={
                      (e, val) => this.changeEntreChevronsPrice(e, val, true)
                    }
                    onBlur={
                      () => {
                        this.changeEntreChevronsPrice(
                          null,
                          { value: entreChevronsItem && entreChevronsItem.price },
                          false,
                        );
                      }
                    }
                  />
                  <Label className={size <= 992 ? 'labelInFormTablette' : 'labelInForm'}>
                    {' '}
                    {t('standard_table_iso_entre_chevrons_price')}
                  </Label>
                </Form>
              </Table.Cell>
              <Table.Cell className="cellTable">
                {' '}
                {(tarifPerSurface || 0)
                  .toFixed(2)
                  .toLocaleString()}
                {' '}
                {t('standard_table_iso_entre_chevrons_tarifsurface')}
              </Table.Cell>
            </Table.Row>
            )}
            <Table.Row>
              <Table.Cell>
                {1 + (showMonocouche ? 0 : 1)}
                .
                {' '}
              </Table.Cell>
              <Table.Cell className="cellTableStandard">
                {t('standard_table_iso_sous_chevrons')}
                <TechnicalInfoIcon
                  t={t}
                  onClick={() => this.clickDownloadPdf(
                    sousChevronsItem && sousChevronsItem.link.length > 0
                      ? sousChevronsItem.link
                      : kitFit035
                  )}
                />
                <br />
                <Dropdown
                  search
                  selection
                  disabled
                  step={0.10}
                  options={sousChevronsOptions}
                  value={sousChevronsItem}
                  onChange={(e, val) => this.changeSousChevrons(e, val)}
                />
              </Table.Cell>
              <Table.Cell className="cellTable">
                {(surfaceSousChevrons || 0).toFixed(2)}
                {' '}
                {t('standard_table_iso_sous_chevrons_surface')}
              </Table.Cell>
              <Table.Cell className="cellTableQuantity">
                {(nbreRouleau || 0).toFixed(2)}
                {' '}
                {t('standard_table_iso_sous_chevrons_rouleau')}
              </Table.Cell>
              <Table.Cell className="cellTableStandard">
                <Form className="inputInTable">
                  <Form.Input
                    type="number"
                    width={8}
                    onClick={e => e.target.select()}
                    step={0.10}
                    disabled={token === null || UserService.isUser()}
                    value={
                      sousChevronsItem && sousChevronsItem.noFormat
                        ? sousChevronsItem && sousChevronsItem.price
                        : Number((sousChevronsItem && sousChevronsItem.price) || 0).toFixed(2)
                    }
                    onChange={
                      (e, val) => this.changeSousChevronsPrice(e, val, true)
                    }
                    onBlur={
                      () => {
                        this.changeSousChevronsPrice(
                          null,
                          {
                            value: sousChevronsItem && sousChevronsItem.price,
                          },
                          false
                        );
                      }
                    }
                  />
                  <Label className={size <= 992 ? 'labelInFormTablette' : 'labelInForm'}>
                    {t('standard_table_iso_sous_chevrons_price')}
                  </Label>
                </Form>
              </Table.Cell>
              <Table.Cell className="cellTable">
                {' '}
                {(tarifOnSurface || 0).toFixed(2)}
                {' '}
                {t('standard_table_iso_sous_chevrons_tarifsurface')}
              </Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell>
                {2 + (showMonocouche ? 0 : 1)}
                .
                {' '}
              </Table.Cell>
              <Table.Cell className="cellTableStandard">
                {t('standard_table_suspentes_trad')}
                <TechnicalInfoIcon
                  t={t}
                  onClick={() => this.clickDownloadPdf(
                    suspentesItem.link && suspentesItem.link.length
                      ? suspentesItem.link
                      : suspentesUrl
                  )}
                />
                <br />
                <Dropdown
                  search
                  selection
                  disabled
                  options={suspentesOptions}
                  default={suspentesItem}
                  value={suspentesItem}
                />
              </Table.Cell>
              <Table.Cell className="cellTable">
                {(suspentes || 0).toFixed(2)}
                {' '}
                {t('standard_table_suspentes_surface')}
              </Table.Cell>
              <Table.Cell className="cellTableQuantity">
                {(suspentesQuantity || 0).toFixed(2)}
                {' '}
                {t('standard_table_suspentes_boites')}
              </Table.Cell>
              <Table.Cell className="cellTableStandard">
                <Form className="cellTableWithoutDropdown">
                  <Form.Input
                    type="number"
                    width={8}
                    onClick={e => e.target.select()}
                    step={0.10}
                    disabled={token === null || UserService.isUser()}
                    value={
                      suspentesItem && suspentesItem.noFormat
                        ? suspentesItem && suspentesItem.price
                        : Number(suspentesItem && suspentesItem.price).toFixed(2)
                    }
                    onChange={(e, val) => this.changeSuspentesPrice(e, val, true)}
                    onBlur={
                      () => {
                        this.changeSuspentesPrice(
                          null,
                          { value: suspentesItem && suspentesItem.price },
                          false
                        );
                      }
                    }
                  />
                  <Label className={size <= 992 ? 'labelInFormTablette' : 'labelInForm'}>
                    {t('standard_table_suspentes_price')}
                  </Label>
                </Form>
              </Table.Cell>
              <Table.Cell className="cellTable">
                {Number(tarifDeSurface || 0).toFixed(2)}
                {t('standard_table_suspentes_tarifsurface')}
              </Table.Cell>
            </Table.Row>
            { /* membrane */ }
            <Table.Row>
              <Table.Cell>
                {3 + (showMonocouche ? 0 : 1)}
                .
              </Table.Cell>
              <Table.Cell className="cellTableStandard">
                {t('standard_table_membrane')}
                <TechnicalInfoIcon
                  t={t}
                  onClick={() => this.clickDownloadPdf(pareVapeur)}
                />
                <br />
                <Dropdown
                  search
                  selection
                  defaultValue={membraneItem}
                  value={membraneItem}
                  options={membraneOptions}
                  onChange={(e, val) => this.changeMembrane(e, val)}
                />
              </Table.Cell>
              <Table.Cell className="cellTable">
                {(membranePareVapeur || 0).toFixed(2)}
                {' '}
                {t('standard_table_membrane_surface')}
              </Table.Cell>
              <Table.Cell className="cellTableQuantity">
                {(membraneRouleaux || 0).toFixed(2)}
                {' '}
                {t('standard_table_membrane_rouleau')}
              </Table.Cell>
              <Table.Cell className="cellTableStandard">
                <Form className="inputInTable">
                  <Form.Input
                    type="number"
                    onClick={e => e.target.select()}
                    width={8}
                    step={0.10}
                    disabled={token === null || UserService.isUser()}
                    style={{ background: '#FFFF00' }}
                    value={
                      membraneItem && membraneItem.noFormat
                        ? membraneItem && membraneItem.price
                        : Number(membraneItem && membraneItem.price).toFixed(2)
                    }
                    onChange={(e, val) => this.changeMembranePrice(e, val, true)}
                    onBlur={
                      () => {
                        this.changeMembranePrice(
                          null,
                          { value: membraneItem && membraneItem.price },
                          false
                        );
                      }
                    }
                  />
                  <Label className={size <= 992 ? 'labelInFormTablette' : 'labelInForm'}>
                    {t('standard_table_membrane_price')}
                  </Label>
                </Form>
              </Table.Cell>
              <Table.Cell className="cellTable">
                {(tarifMembrane || 0).toFixed(2)}
                {' '}
                {t('standard_table_membrane_tarifsurface')}
              </Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell>
                {4 + (showMonocouche ? 0 : 1)}
                .
                {' '}
              </Table.Cell>
              <Table.Cell className="cellTableStandard">
                {t('standard_table_adhesif')}
                <TechnicalInfoIcon
                  t={t}
                  onClick={() => this.clickDownloadPdf(adhesifRtmaxPdf)}
                />
                <br />
              </Table.Cell>
              <Table.Cell className="cellTable">
                {(usedAdhesif || 0).toFixed(2)}
                {' '}
                {t('standard_table_adhesif_surface')}
              </Table.Cell>
              <Table.Cell className="cellTableQuantity">
                {(adhesifBox || 0).toFixed(2)}
                {' '}
                {t('standard_table_adhesif_rouleau')}
              </Table.Cell>
              <Table.Cell className="cellTableStandard">
                <Form className="cellTableWithoutDropdown">
                  <Form.Input
                    type="number"
                    onClick={e => e.target.select()}
                    width={8}
                    step={0.10}
                    disabled={token === null || UserService.isUser()}
                    value={adhesifNoFormat ? adhesifPrice : Number(adhesifPrice).toFixed(2)}
                    onChange={(e, val) => this.changeAdhesifPrice(e, val)}
                  />
                  <Label className={size <= 992 ? 'labelInFormTablette' : 'labelInForm'}>
                    {t('standard_table_adhesif_price')}
                  </Label>
                </Form>
              </Table.Cell>
              <Table.Cell className="cellTable">
                {(adhesifCost || 0).toFixed(2)}
                {' '}
                {t('standard_table_adhesif_tarifsurface')}
              </Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell>
                {5 + (showMonocouche ? 0 : 1)}
                .
                {' '}
              </Table.Cell>
              <Table.Cell className="cellTableStandard">
                {t('standard_table_solidouble')}
                <TechnicalInfoIcon
                  t={t}
                  onClick={() => this.clickDownloadPdf(solidoublePdf)}
                />
                <br />
              </Table.Cell>
              <Table.Cell className="cellTable">
                {(solidouble || 0).toFixed(2)}
                {' '}
                {t('standard_table_solidouble_surface')}
              </Table.Cell>
              <Table.Cell className="cellTableQuantity">
                {' '}
                {(solidoubleQuantity || 0).toFixed(2)}
                {' '}
                {t('standard_table_solidouble_rouleau')}
              </Table.Cell>
              <Table.Cell className="cellTableStandard">
                <Form className="cellTableWithoutDropdown">
                  <Form.Input
                    type="number"
                    onClick={e => e.target.select()}
                    width={8}
                    step={0.10}
                    disabled={token === null || UserService.isUser()}
                    value={solidoubleNoFormat
                      ? solidoublePrice
                      : Number(solidoublePrice).toFixed(2)
                    }
                    onChange={(e, val) => this.changeSolidoublePrice(e, val, true)}
                    onBlur={
                      () => {
                        this.changeSolidoublePrice(null, { value: solidoublePrice }, false);
                      }
                    }
                  />
                  <Label className={size <= 992 ? 'labelInFormTablette' : 'labelInForm'}>
                    {t('standard_table_solidouble_price')}
                  </Label>
                </Form>
              </Table.Cell>
              <Table.Cell className="cellTable">
                {Number(tarifSolidouble || 0).toFixed(2)}
                {' '}
                {t('standard_table_solidouble_tarifsurface')}
              </Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell>
                {6 + (showMonocouche ? 0 : 1)}
                .
                {' '}
              </Table.Cell>
              <Table.Cell className="cellTableStandard">
                {t('standard_table_mastic')}
                <TechnicalInfoIcon
                  t={t}
                  onClick={() => this.clickDownloadPdf(masticRtPdf)}
                />
                <br />
              </Table.Cell>
              <Table.Cell className="cellTable">
                {(masticRT || 0).toFixed(2)}
                {' '}
                {t('standard_table_mastic_surface')}
              </Table.Cell>
              <Table.Cell className="cellTableQuantity">
                {(masticrtQuantity || 0).toFixed(2)}
                {' '}
                {t('standard_table_mastic_cartouches')}
              </Table.Cell>
              <Table.Cell className="cellTableStandard">
                <Form className="cellTableWithoutDropdown">
                  <Form.Input
                    type="number"
                    onClick={e => e.target.select()}
                    width={8}
                    step={0.10}
                    disabled={token === null || UserService.isUser()}
                    value={
                      masticNoFormat
                        ? masticrtPrice
                        : Number(masticrtPrice).toFixed(2)
                    }
                    onChange={(e, val) => this.changeMasticrtPrice(e, val, true)}
                    onBlur={() => this.changeMasticrtPrice(null, { value: masticrtPrice }, false)}
                  />
                  <Label className={size <= 992 ? 'labelInFormTablette' : 'labelInForm'}>
                    {t('standard_table_mastic_price')}
                  </Label>
                </Form>
              </Table.Cell>
              <Table.Cell className="cellTable">
                {Number(tarifMasticRt || 0).toFixed(2)}
                {' '}
                {t('standard_table_mastic_tarifsurface')}
                {' '}
              </Table.Cell>
            </Table.Row>
          </Table.Body>
        </Table>

        <Modal
          id="IncompatibleRModal"
          open={modalStandardMonocoucheOpen}
          onClose={this.handleClose}
        >
          <Header
            icon="times"
            color="red"
            content="Aucune solution"
          />
          <Modal.Content>
            <h3>{t('incompatible_modal_standard_resistance')}</h3>
          </Modal.Content>
          <Modal.Actions>
            <Link
              to={{
                pathname: '/combles_amenage/compare',
                state,
              }}
            >
              <Button
                color="red"
                onClick={this.handleClose}
                inverted
              >
                <Icon name="reply" />
                {' '}
                {t('incompatible_modal_ok')}
              </Button>
            </Link>
          </Modal.Actions>
        </Modal>

        <Modal
          id="IncompatibleRModal"
          open={modalOpen}
          onClose={this.handleCloseConfig}
        >
          <Header
            icon="times"
            color="red"
            content={t('title_modal_impossible_configuration')}
          />
          <Modal.Content>
            <h3>{t('incompatible_modal_epaisseur_resistance')}</h3>
          </Modal.Content>
          <Modal.Actions>
            <Link
              to={{
                pathname: '/combles_amenage/compare',
                state,
              }}
            >
              <Button
                color="red"
                onClick={this.handleCloseConfig}
                inverted
              >
                <Icon name="checkmark" />
                OK
              </Button>
            </Link>
          </Modal.Actions>
        </Modal>
      </div>

    );
  }
}

export default translate('StandardSoluceComponent')(ComponentTable);



// WEBPACK FOOTER //
// ./src/components/Protected/standard/ComponentTable.jsx